import React from 'react';
import { Link } from 'react-router';
import { logout as logoutActionCreator } from '../../actions/session';

export default function Sidemenu(props) {

    const logout = function(evt) {
        props.dispatch(logoutActionCreator());
        props.toggleSidemenu();
    }

    return (
        <div>
            <ul className="nav nav-pills flex-column">
                <li className="nav-item">
                    <SidemenuLink href="/" activeClassName="active" toggleSidemenu={props.toggleSidemenu}>Inicio</SidemenuLink>
                </li>
                <li className="nav-item">
                    <SidemenuLink href="/users" activeClassName="active" toggleSidemenu={props.toggleSidemenu}>Usuarios</SidemenuLink>
                </li>
                <li className="nav-item">
                    <SidemenuLink href="/reports/products" activeClassName="active" toggleSidemenu={props.toggleSidemenu}>Productos solicitados</SidemenuLink>
                </li>
                <li className="nav-item">
                    <SidemenuLink href="/reports/evaluations" activeClassName="active" toggleSidemenu={props.toggleSidemenu}>Evaluaciones</SidemenuLink>
                </li>
                <li className="nav-item">
                    <SidemenuLink href="/reports/surveys" activeClassName="active" toggleSidemenu={props.toggleSidemenu}>Encuestas</SidemenuLink>
                </li>
                <li className="nav-item">
                    <SidemenuLink href="/reports/accompaniment" activeClassName="active" toggleSidemenu={props.toggleSidemenu}>Acompañamiento</SidemenuLink>
                </li>

                <li className="nav-item">
                    <SidemenuLink href="/sale-support" activeClassName="active" toggleSidemenu={props.toggleSidemenu}>Apoyo a la venta</SidemenuLink>
                </li>

                <li className="nav-item">
                    <SidemenuLink href="/communiques" activeClassName="active" toggleSidemenu={props.toggleSidemenu}>Comunicados</SidemenuLink>
                </li>

                <li className="nav-item">
                    <SidemenuLink href="/uploads" activeClassName="active" toggleSidemenu={props.toggleSidemenu}>Cargas</SidemenuLink>
                </li>
            </ul>

            <hr />

            <ul className="nav nav-pills flex-column">
                <li className="nav-item">
                    <a className="nav-link" href="/" onClick={logout}>
                        Cerrar sesión
                    </a>
                </li>
            </ul>
        </div>
        
    );
}

function SidemenuLink(props) {
    return (
        <Link to={props.href} className="nav-link" onClick={props.toggleSidemenu}>
            {props.children}
        </Link>
    );
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/Sidemenu.jsx
 **/